import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBecepsLeftArm: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="beceps-left-arm, strong, flex, power"><path d="M11.7577 12.9014C8.91667 7.88889 2.7476 9.85207 2.75 14.7286C2.75 22.8319 16.2467 22.3211 20.943 18.9101C22.4728 10.2147 18.0403 2.75 13.0811 2.75C8.09667 2.75 11.2026 9.66075 14.9594 6.43573" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M13.3853 7.375C15.8925 11.0263 14.4319 12 15.6978 14.7752C13.759 13.1133 11.4998 12.1412 9.22266 13.85" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBecepsLeftArm;
